import { ArrowUp, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Primitives";
import { useT } from "@/lib/i18n";
import { scrollToId } from "@/lib/scroll";
import { openCookiePrefs } from "./CookieBanner";

export const Footer = () => {
  const t = useT().footer;
  const prefs = useT().cookies.prefs;
  const c = useT().cookies;
  return (
    <footer className="pt-20 pb-8 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex items-center gap-3"><Logo className="w-10 h-10" /><span className="font-mono text-xs uppercase tracking-[0.2em] text-stone-400">Social Media Manager & Web Designer</span></div>
          <div className="flex items-center gap-6 text-sm">
            <a href="https://www.instagram.com/lenemauro/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" aria-label="Instagram"
              className="inline-flex items-center gap-2 text-stone-300 hover:text-[var(--gold)] transition-colors">
              <Instagram size={16} /> Instagram
            </a>
            <a href="mailto:lenemauro1990@gmail.com" data-testid="footer-email-link" className="link-underline text-stone-300">{t.write}</a>
            <button onClick={() => scrollToId("top")} data-testid="footer-top-btn" className="inline-flex items-center gap-2 text-stone-300 hover:text-[var(--gold)] transition-colors">
              {t.top} <ArrowUp size={16} />
            </button>
          </div>
        </div>
        <p className="mt-14 font-display font-light leading-[0.8] tracking-[-0.04em] text-[22vw] md:text-[17vw] whitespace-nowrap select-none footer-word" data-testid="footer-wordmark">
          Lene <span className="italic text-[var(--gold)]">Mauro</span>
        </p>
        <div className="mt-8 pt-6 border-t border-[var(--line)] flex justify-between font-mono text-xs text-stone-400">
          <span>© {new Date().getFullYear()} Lene Mauro</span>
          <span>{t.rights} · <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[var(--gold)] transition-colors">{c.privacy}</Link> · <button onClick={openCookiePrefs} data-testid="footer-cookie-prefs-btn" className="hover:text-[var(--gold)] transition-colors">{prefs}</button></span>
        </div>
      </div>
    </footer>
  );
};
